import { AutocompleteItem } from '@prismamedia/one-components';
import {
  BrandKey,
  GetArticleQuery_query_article_Article_tags_ArticleTag_tag_Tag,
  TagType,
} from '../../../../__generated__/queries-web';
import { isArticleVideo } from '../../../../utils/url';
import { brandsOptions } from '../../../../utils/brands';

export const isBrandkeyCanHavePersonTag = (
  tagProviderName: TagType,
  brandKey: BrandKey,
) =>
  tagProviderName === TagType.Person
    ? brandsOptions[brandKey].personTagsAllowed
    : true;

export const isTagAlreadyCreated = (
  selectedTagList: GetArticleQuery_query_article_Article_tags_ArticleTag_tag_Tag[],
  search?: string,
) =>
  !!(
    selectedTagList.length &&
    selectedTagList.find(
      ({ title }) =>
        title.toLowerCase().trim() === search?.toLowerCase().trim(),
    )
  );

export const isTagAlreadyListed = (
  autocompleteList: AutocompleteItem[],
  search?: string,
) =>
  !!(
    autocompleteList.length &&
    autocompleteList.find(
      ({ additionnals }) =>
        additionnals?.title.toLowerCase().trim() ===
        search?.toLowerCase().trim(),
    )
  );

export const getTagTypeFromPathname = (pathname: string): TagType =>
  isArticleVideo(pathname) ? TagType.Video : TagType.Tag;
